import Swiper, { Navigation, Pagination, Autoplay, EffectFade, SwiperOptions } from 'swiper';
import '../css/index.css';

document.addEventListener('DOMContentLoaded', () => {

  interface SwiperSetting {
    role: string;
    options: SwiperOptions;
    useFade?: boolean;
    useAutoplay?: boolean;
  }

  const baseOptions: SwiperOptions = {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    speed: 1500,
    pagination: {
      clickable: true,
    },
  };

  const swiperConfigs: SwiperSetting[] = [
    {
      role: 'top-mv-swiper',
      useAutoplay: true,
      useFade: true,
      options: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        toggleButton: true,
      },
    },
    {
      role: 'top-recommended-swiper',
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 32
          },
        },
      },
    },
    {
      role: 'top-modelcourse-swiper',
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          1024: { slidesPerView: 3, spaceBetween: 32 },
        },
      },
    },

    // 下層swiper
    {
      role: 'reports-mv-swiper',
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
    },
    {
      role: 'single-mv-swiper',
      options: {
        slidesPerView: 1.4,
        spaceBetween: 48,
        centeredSlides: true,
        centerInsufficientSlides: true,
      },
    },
    {
      role: 'areas-swiper',
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          1024: { slidesPerView: 3, spaceBetween: 32 },
        },
      },
    },
    {
      role: 'areas-mv-swiper',
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
    },
  ];

  // すべてのスライダー初期化
  swiperConfigs.forEach(({ role, options, useFade, useAutoplay }) => {
    const selector = `[data-role="${role}"]`;
    const element = document.querySelector(selector);
    if (!element) return;

    // Swiper初期化
    const swiper = new Swiper(element as HTMLElement, {
      ...baseOptions,
      ...options,
      ...(useFade && {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      }),
      ...(useAutoplay && {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }),
      navigation: {
        nextEl: `[data-role="${role}-nav-next"]`,
        prevEl: `[data-role="${role}-nav-prev"]`,
      },
      pagination: {
        el: `[data-role="${role}-nav-pagination"]`,
        clickable: true,
      },
    });

    // === 自動再生の再生・停止ボタン設定 ===
    const toggleBtn = (element as HTMLElement).querySelector('[data-role="swiper-toggle"]');
    if (toggleBtn) {
      const pauseIcon = toggleBtn.querySelector('.icon-pause');
      const playIcon = toggleBtn.querySelector('.icon-play');
      let isPlaying = true;

      toggleBtn.addEventListener('click', () => {
        if (isPlaying) {
          swiper.autoplay.stop();
          pauseIcon?.classList.add('hidden');
          playIcon?.classList.remove('hidden');
        } else {
          swiper.autoplay.start();
          playIcon?.classList.add('hidden');
          pauseIcon?.classList.remove('hidden');
        }
        isPlaying = !isPlaying;
      });
    }
  });
});
